import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import SiteLayout from "../components/feature/SiteLayout";
import Home from "../pages/home/page";
import CategoryPage from "../pages/category/page";
import ListPage from "../pages/list/page";
import DetailPage from "../pages/detail/page";
import ReadPage from "../pages/read/page";
import SearchPage from "../pages/search/page";
import FavoritesPage from "../pages/favorites/page";
import About from "../pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: "category/:categoryId", element: <CategoryPage /> },
      { path: "list", element: <ListPage /> },
      { path: "detail/:comicId", element: <DetailPage /> },
      { path: "read/:comicId/:chapterId", element: <ReadPage /> },
      { path: "search", element: <SearchPage /> },
      { path: "user/favorites", element: <FavoritesPage /> },
      { path: "about", element: <About /> },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;